{
  "en": {
    "cancel-edit": "Cancel",
    "save-edit": "Save"
  },
  "fr": {
    "cancel-edit": "Annuler",
    "save-edit": "Sauvegarder"
  }
}